module.exports = __webpack_public_path__ + "img/visa-logo.bd687161.svg";